import React, { ReactElement, useCallback, memo, Fragment } from 'react'

const estiloDropDown = require("./dropdown-exibicao-itens.module.scss").default;

export type ItemDropdown = {
    titulo: string
    componenteExibicao: ReactElement
    exibirDropdown: boolean
}

export type DropdownExibicaoItensProps = {
    itens: ItemDropdown[]
    onClickItem: (item: ItemDropdown) => void
}

// Componente memoizado para cada item
const Item = memo(({ item, onClickItem }: { item: ItemDropdown; onClickItem: (item: ItemDropdown) => void }) => {
    const handleClick = useCallback(() => {
        onClickItem(item)
    }, [onClickItem, item])

    return (
        <Fragment>
            <div className={estiloDropDown.botao}>
                <span 
                    onClick={handleClick} 
                    className={estiloDropDown.texto}
                >
                    {item.titulo}
                </span>
            </div>
            {item.exibirDropdown && (
                <div className={estiloDropDown.corpo}>
                    {item.componenteExibicao}
                </div>
            )}
        </Fragment>
    )
})

// Componente principal memoizado
export const DropdownExibicaoItens = memo(({ itens, onClickItem }: DropdownExibicaoItensProps) => {
    return (
        <>
            {itens.map((item) => (
                <Item 
                    key={item.titulo} // Usando título como chave (garanta que seja único)
                    item={item}
                    onClickItem={onClickItem}
                />
            ))}
        </>
    )
})